import { ORDER_PRIMARY_PHASE_METRICS } from '../../pipeline/lib/orderPrimaryPhaseMetric';

export const STATISTICS_DASHBOARD_VARIANT = {
	MANAGEMENT: 'management',
	SALE: 'sale',
};

export const resolveStatisticsDashboardVariant = (role) => (role === 'sale' ? STATISTICS_DASHBOARD_VARIANT.SALE : STATISTICS_DASHBOARD_VARIANT.MANAGEMENT);

export const SALE_DASHBOARD_BAR_TITLE = '流程分布 · 合同金额';
export const SALE_DASHBOARD_PIE_TITLE = '合同金额 / 单数占比';
export const SALE_DASHBOARD_OVERDUE_TITLE = '超期客户排行';

/** 经营看板预制图统一绘图区高度（加载态与完成后一致） */
export const DASHBOARD_PRESET_PLOT_HEIGHT_BY_METRIC = {
	[ORDER_PRIMARY_PHASE_METRICS.TOTAL_PRICE]: '20rem',
	[ORDER_PRIMARY_PHASE_METRICS.COUNT]: '18rem',
};

export const DASHBOARD_PRESET_PLOT_HEIGHT_DEFAULT = '15rem';

/** @deprecated 使用 resolveDashboardPresetPlotHeight */
export const DASHBOARD_PRESET_DUAL_PIE_HEIGHT = DASHBOARD_PRESET_PLOT_HEIGHT_BY_METRIC[ORDER_PRIMARY_PHASE_METRICS.TOTAL_PRICE];

export const resolveDashboardPresetPlotHeight = (activeMetric) => DASHBOARD_PRESET_PLOT_HEIGHT_BY_METRIC[activeMetric] ?? DASHBOARD_PRESET_PLOT_HEIGHT_DEFAULT;

/** 贡献排行（横向条形图 topN）需要比流程分布更高的绘图区 */
export const DASHBOARD_PRESET_DIMENSION_PLOT_HEIGHT_BY_METRIC = {
	[ORDER_PRIMARY_PHASE_METRICS.TOTAL_PRICE]: '26rem',
	[ORDER_PRIMARY_PHASE_METRICS.COUNT]: '24rem',
};

export const DASHBOARD_PRESET_DIMENSION_PLOT_HEIGHT_DEFAULT = '22rem';

export const resolveDashboardPresetDimensionPlotHeight = (activeMetric) =>
	DASHBOARD_PRESET_DIMENSION_PLOT_HEIGHT_BY_METRIC[activeMetric] ?? DASHBOARD_PRESET_DIMENSION_PLOT_HEIGHT_DEFAULT;

/** @deprecated 使用 resolveDashboardPresetPlotHeight */
export const resolveDashboardPresetPieHeight = (activeMetric, inlineMapHeight = DASHBOARD_PRESET_PLOT_HEIGHT_DEFAULT) =>
	resolveDashboardPresetPlotHeight(activeMetric) || inlineMapHeight;

/** 锁定经营看板预制图绘图槽高度 */
export const buildDashboardPresetPlotBodyStyle = (height = DASHBOARD_PRESET_PLOT_HEIGHT_DEFAULT) => ({
	'--dashboard-preset-plot-height': height,
	flex: `0 0 ${height}`,
	minHeight: height,
	height,
	overflow: 'hidden',
	boxSizing: 'border-box',
});

/**
 * 预制图槽内子节点（加载态 / 图表）统一高度契约：
 * - 经营看板槽位：与 buildDashboardPresetPlotBodyStyle 同一 rem，避免 fillSlot 100% 链断裂
 * - 全屏弹层 fillSlot：父容器撑满时用 100%
 */
export const resolveDashboardPresetPlotChildStyle = (height = DASHBOARD_PRESET_PLOT_HEIGHT_DEFAULT, { fillSlot = false } = {}) =>
	fillSlot
		? { height: '100%', width: '100%', minHeight: 0 }
		: { height, minHeight: height, width: '100%' };

export const buildDashboardPresetPlotLoadingStyle = (height, options) => resolveDashboardPresetPlotChildStyle(height, options);

export const resolveDashboardBarMetric = (variant, activeMetric) => (variant === STATISTICS_DASHBOARD_VARIANT.SALE ? ORDER_PRIMARY_PHASE_METRICS.TOTAL_PRICE : activeMetric);

export const resolveDashboardBarDualPhaseMetric = (variant) => variant !== STATISTICS_DASHBOARD_VARIANT.SALE;
